import React from "react";
import EDCInfo from "./edc-info/EDCInfo";
import MEDInfo from "./med-info/MEDInfo";
export const Headline = (product) => {
  if (product === "edc15") {
    return "EDC15 Multimap";
  } else if (product === "med9") {
    return "MED9 Multimap";
  }
};
export const Video = (product) => {
  if (product === "edc15") {
    return "https://www.youtube.com/embed/7tuTOx9vNXM";
  } else if (product === "med9") {
    return "https://www.youtube.com/embed/SWjUMWkDeZc";
  }
};
export const Instructions = (product) => {
  if (product === "edc15") {
    return <EDCInfo />;
  } else if (product === "med9") {
    return <MEDInfo />;
  }
};
export const AppPageDetails = (product) => {
  if (product === "edc15") {
    return <>EDC15 Multimap/Mapswitch tool</>;
  } else if (product === "med9") {
    return <>MED9 Multimap/Mapswitch tool</>;
  }
};
